
export enum ImageCategory {
    Normal = 1,
    Extra = 2
}